import type { AppState, GetterClass } from '../../../models'

export class AlreadyLoggedInOnceGetter implements GetterClass {
  static execute(this: void, state: AppState): boolean {
    return state.alreadyLoggedInOnce
  }
}
